import React, { useMemo } from "react"
import { MenuItem, Stack, Typography } from "@mui/material"
import { FaIcon } from "../../../../mp-core/icons"
import Chip from "../Chip"
import { RuleName, useStyles } from "./styles"
import { DropdownMenuOptions } from "./DropdownMenuItem"
import { lightBlue, blueGrey } from "../../../../mp-core/themes/palette"

interface Props {
  label: string | React.ReactNode
  children: DropdownMenuOptions[]
  isExpanded: boolean
  onToggle: () => void
  classes?: Partial<Record<RuleName, string>>
  ["data-automation-id"]?: string
}

export const CollapsibleMenuHeader: React.FC<Props> = ({
  label,
  children,
  isExpanded,
  onToggle,
  classes: outerClasses,
  ["data-automation-id"]: dataAutomationId
}) => {
  const { classes, cx } = useStyles()

  const selectedCount = useMemo(() => {
    return children.filter(child => child.selected).length
  }, [children])

  return (
    <MenuItem
      tabIndex={0}
      className={cx(classes.collapsibleHeader, outerClasses?.collapsibleHeader)}
      data-automation-id={dataAutomationId}
      disableRipple
      onClick={onToggle}
      onKeyDown={e => e.stopPropagation()}
    >
      <Stack width="100%" direction="row" spacing={2} alignItems="center">
        <Chip
          size="xs"
          label={selectedCount > 0 ? selectedCount : "--"}
          className={cx(classes.collapsibleChip, {
            [classes.collapsibleSelectedChip]: selectedCount > 0
          })}
        />

        <Typography flex={1} variant="body2">
          {label}
        </Typography>

        <FaIcon
          solid
          name={isExpanded ? "chevron-up" : "chevron-down"}
          className={cx(classes.collapsibleChevron)}
        />
      </Stack>
    </MenuItem>
  )
}
